import { useAuth0 } from "@auth0/auth0-react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import MyButton from "../../../components/MyButton";
import Service from "../../../Lib/service";
import "./styles.scss";

const formatOptionLabel = ({ label, account_id }) => {
	return (
		<div className="dropdown-container" key={account_id}>
			<div className="icon-name-container d-flex align-items-center justify-content-start">
				<div className="name-container" style={{ marginInlineStart: 10 }}>
					<div>{label}</div>
				</div>
			</div>
		</div>
	);
};

const colourStyles = {
	control: (styles) => ({
		...styles,
		...selectControlStyles,
	}),
	menuList: (styles) => ({
		...styles,
		maxHeight: "150px",
	}),
};

const selectControlStyles = {
	backgroundColor: "#F3F6F9",
	borderColor: "#F3F6F9",
	color: "#3F4254",
	transition: "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
	paddingTop: "6px",
	paddingBottom: "6px",
	cursor: "pointer",
};

const usePlaceholderStyles = makeStyles((theme) => ({
	placeholder: {
		color: "#aaa",
		fontSize: "14px",
	},
}));

const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<BottomArrowSvg label="Emoji" />
		</components.DropdownIndicator>
	);
};

const AssignTask = ({ closeModal, selectedTask, updateTaskHandler, updateTaskLoading }) => {
	console.log("selectedTask :", selectedTask);
	const [loading, setLoading] = React.useState(false);
	const [userData, setUserData] = useState(false);
	const [assignTo, setAssignTo] = useState({});

	const { getAccessTokenSilently } = useAuth0();

	const getEventUsers = async (token, page) => {
		const url = `/pastoral/users/?current_page=${page}&items_per_page=5000`;
		try {
			return await Service.get(url, token);
		} catch (error) {
			throw error;
		}
	};

	const fetchUsersApi = async (page) => {
		setLoading(true);
		const token = await getAccessTokenSilently();
		getEventUsers(token, page)
			.then((res) => {
				if (res) {
					setUserData(res?.users);
					setLoading(false);
				}
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	React.useEffect(() => {
		fetchUsersApi(1);
	}, []);

	const options1 =
		userData &&
		userData?.map((item) => {
			return {
				label: `${item?.type} ${item?.fullName ? "- " + item?.fullName : ""}`,
				value: item?.id,
			};
		});

	const assignHandler = () => {
		updateTaskHandler({
			key: 4,
			id: selectedTask?.id,
			assignValue: assignTo?.id,
			successMsg: `Task assigned to ${assignTo?.name}`,
		});
	};

	return (
		<div className=" assign-drawer p-10  mt-5 h-100" style={{ width: "487px" }}>
			<h1 className="NewEvent-heading">Assign Task </h1>
			<div className="addEvent-form d-flex flex-column justify-content-between mt-10" style={{ height: "82%" }}>
				<>
					<div className="form-group Account-name-newEvent  mt-5 h-100 ">
						<p className="assign-subHeading mb-2">
							<span>Who would you like to assign {selectedTask?.name}</span> - {selectedTask?.descreption} to?
						</p>
						<Select
							{...{
								name: `assignTo`,
								checkValidation: false,
							}}
							classNamePrefix="react-select"
							formatOptionLabel={formatOptionLabel}
							options={options1}
							isLoading={loading}
							styles={colourStyles}
							onChange={(value) => {
								setAssignTo({
									id: value.value,
									name: value.label,
								});
							}}
							value={
								assignTo
									? {
											label: assignTo?.name,
											value: assignTo?.id,
									  }
									: ""
							}
							components={{ DropdownIndicator }}
						/>
					</div>

					<div className="d-flex justify-content-between mt-20">
						<a className="close-btn d-flex align-items-center" onClick={() => closeModal()}>
							Close
						</a>
						<div className="saveBtn-drawer">
							<MyButton
								type={"primary"}
								content={
									updateTaskLoading ? (
										<div className="d-flex align-items-center justify-content-center">
											<CircularProgress
												size={20}
												style={{
													color: "#ffffff",
												}}
											/>
										</div>
									) : (
										"Save"
									)
								}
								onClick={() => {
									assignHandler();
								}}
								disabled={!assignTo?.id || updateTaskLoading}
								variant="outlined"
							/>
						</div>
					</div>
				</>
			</div>
		</div>
	);
};
export default AssignTask;
